<template>
    <div>
        <div id="layout">
            <VVisually></VVisually>
            <VHeader></VHeader>
            <div id="bread-crumbs">
                <div class="holder">
                    <ul>
                        <li><a href="/">Главная</a></li>
                        <li>{{ pageName }}</li>
                    </ul>
                </div>
            </div>

            <section id="content">
                <div class="holder">
                    <article class="wnd" id="message">
                        <div v-html="content.fields.content"></div>
                    </article>
                </div>
            </section>
        </div>

        <VFooter></VFooter>
    </div>
</template>

<script>
    import PageScripts from '../assets/js/page-scripts.js';

    import VHeader from '../components/VHeader.vue';
    import VFooter from '../components/VFooter.vue';
    import Application from "../application";
    import VVisually from "../components/VVisually.vue";

    export default {
        components: {
            'VVisually': VVisually,
            'VHeader': VHeader,
            'VFooter': VFooter,
        },

        data: function () {
            return {
                //canInteract: true,
                content: null,
                pageName: null,
            }
        },

        created: function () {

            Application.process('/' + this.$route.params.id, false);
            var element = ContentAPI.element(this.$route.params.id, false, null, null);
            if (!element) {
                element = ContentAPI.element("404", false, null, null);
                this.pageName = "Ошибка";
            } else {
                this.pageName = element.name;
            }

            this.content = element;
        },

        mounted: function() {
            PageScripts.initialize();
        },

        methods: {

        }
    }


</script>


// WEBPACK FOOTER //
// CustomPage.vue?13691842